import React, { useState } from 'react';

import StandardModal from 'components/consumer/StandardModal';
import useScreen from 'hooks/useScreen';
import KeySellingPointsBarItem from '../KeySellingPointsBarItem';
import SwatchRequestIcon from '../icons/SwatchRequestIcon';

const itemTitle = 'Free Swatch Kit';
const itemContent =
  "Want to be sure you're choosing the right fabric? Order a free swatch kit to experience our fabrics up close and personal!";

const FreeSwatchKitItem = ({ openMobileModal }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isMobileOrTablet } = useScreen();

  return (
    <>
      <KeySellingPointsBarItem
        icon={<SwatchRequestIcon color="currentColor" />}
        onClick={() => {
          if (isMobileOrTablet) {
            openMobileModal({
              content: itemContent,
              icon: <SwatchRequestIcon color="white" />,
            });
          } else {
            setIsOpen(true);
          }
        }}
      >
        {itemTitle}
      </KeySellingPointsBarItem>

      <StandardModal
        isOpen={isOpen}
        icon={<SwatchRequestIcon color="white" />}
        onClose={() => {
          setIsOpen(false);
        }}
        title={itemTitle}
      >
        {itemContent}
      </StandardModal>
    </>
  );
};

export default FreeSwatchKitItem;
